// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mrNG","importantInfo":"styles_importantInfo__3c_Yr"};